import api from "./apis/api";

class MolassesService {
  create(data) {
    return api.molasses.create(data);
  }
  getList(data) {
    return api.molasses.getList(data);
  }
  getMolasses(id) {
    return api.molasses.getMolasses(id);
  }
  updateMolasses(data) {
    return api.molasses.updateMolasses(data);
  }
  getFermentationOptions() {
    return api.molasses.getFermentationOptions();
  }
  sendToFermentation(data) {
    return api.molasses.sendToFermentation(data);
  }
  removeMolassesFermentation(id) {
    return api.molasses.removeMolassesFermentation(id);
  }
}

export default new MolassesService();
